import { CustomValidators } from 'ng2-validation';
import { AbstractControl, ValidationErrors, ValidatorFn, Validators as AngularValidators } from '@angular/forms';
import { isDate } from 'ng2-validation/dist/util/lang';

export const equal = (val: any) => {
    return (control: AbstractControl): ValidationErrors | null => {

        if (!control.value) {
            return null;
        }

        if (control.value === val) {
            return null;
        }

        return {
            equal: {
                value: val
            }
        };
    };
};

export const notEqual = (val: any) => {
    return (control: AbstractControl): ValidationErrors | null => {

        if (!control.value) {
            return null;
        }

        if (control.value !== val) {
            return null;
        }

        return {
            notEqual: {
                value: val
            }
        };
    };
};

export const between = (range: Array<number>) => {
    return (control: AbstractControl): ValidationErrors | null => {

        if (!control.value) {
            return null;
        }

        if (control.value >= range[0] && control.value <= range[1]) {
            return null;
        }

        return {
            between: {
                value: control.value,
                min: range[0],
                max: range[1],
            }
        };
    };
};

export const minDate = (min: string): ValidatorFn => {
    if (!isDate(min)) {
        throw Error('min value must be or return a formatted date');
    }

    return (control: AbstractControl): { [key: string]: any } => {
        if (!control.value) {
            return null;
        }

        if (new Date(control.value) >= new Date(min)) {
            return null;
        }

        return {
            minDate: min
        };
    };
};

export const maxDate = (max: string): ValidatorFn => {
    if (!isDate(max)) {
        throw Error('max value must be or return a formatted date');
    }

    return (control: AbstractControl): { [key: string]: any } => {
        if (!control.value) {
            return null;
        }

        if (new Date(control.value) <= new Date(max)) {
            return null;
        }

        return {
            maxDate: max
        };
    };
};

export const CoreValidators = [
    {
        name: 'required',
        validator: AngularValidators.required,
        message: 'The {{attribute}} field is required.',
        parameters: false,
        parameter_type: null
    },
    {
        name: 'minlength',
        validator: AngularValidators.minLength,
        message: 'The {{attribute}} must be at least {{min}} characters.',
        parameters: true,
        parameter_type: 'number'
    },
    {
        name: 'maxlength',
        validator: AngularValidators.maxLength,
        message: 'The {{attribute}} may not be greater than {{max}} characters.',
        parameters: true,
        parameter_type: 'number'
    },
    {
        name: 'pattern',
        validator: AngularValidators.pattern,
        message: 'The {{attribute}} does not match the format {{format}}.',
        parameters: true,
        parameter_type: 'string'
    },
    {
        name: 'betweenLength',
        validator: CustomValidators.rangeLength,
        message: 'The {{attribute}} must be between {{min}}and {{max}} characters.',
        parameters: true,
        parameter_type: null
    },
    {
        name: 'min',
        validator: CustomValidators.min,
        message: 'The {{attribute}} must be at least {{min}}.',
        parameters: true,
        parameter_type: 'number'
    },
    // {
    //     name: 'gt',
    //     validator: CustomValidators.gt,
    //     message: '',
    //     parameters: true,
    //     parameter_type: 'string'
    // },
    {
        name: 'gte',
        validator: CustomValidators.gte,
        message: 'The {{attribute}} must be at least {{min}}.',
        parameters: true,
        parameter_type: 'number'
    },
    {
        name: 'max',
        validator: CustomValidators.max,
        message: 'The {{actualValue}} may not be greater than {{max}}.',
        parameters: true,
        parameter_type: 'number'
    },
    // {
    //     name: 'lt',
    //     validator: CustomValidators.lt,
    //     message: '',
    //     parameters: true,
    //     parameter_type: 'string'
    // },
    {
        name: 'lte',
        validator: CustomValidators.lte,
        message: 'The {{attribute}} may not be greater than {{max}}.',
        parameters: true,
        parameter_type: 'number'
    },
    {
        name: 'between',
        validator: between,
        message: 'The {{attribute}} must be between {{min}} and {{max}}.',
        parameters: true,
        parameter_type: 'number'
    },
    {
        name: 'digits',
        validator: CustomValidators.digits,
        message: 'The {{attribute}} must be {{digits}} digits',
        parameters: false,
        parameter_type: null
    },
    {
        name: 'number',
        validator: CustomValidators.number,
        message: 'The {{attribute}} must be a number.',
        parameters: false,
        parameter_type: null
    },
    {
        name: 'url',
        validator: CustomValidators.url,
        message: 'The {{attribute}} is not a valid URL. Must be prefixed by http:// or https://.',
        parameters: false,
        parameter_type: null
    },
    {
        name: 'email',
        validator: CustomValidators.email,
        message: 'The {{attribute}} must be a valid email address.',
        parameters: false,
        parameter_type: null
    },
    {
        name: 'date',
        validator: CustomValidators.date,
        message: 'The {{attribute}} is not a valid date.',
        parameters: false,
        parameter_type: null
    },
    {
        name: 'minDate',
        validator: minDate,
        message: 'The {{attribute}} must be a date after or equal to {{date}}.',
        parameters: true,
        parameter_type: 'date'
    },
    {
        name: 'maxDate',
        validator: maxDate,
        message: 'The {{attribute}} must be a date before or equal to {{date}}.',
        parameters: true,
        parameter_type: 'date'
    },
    // {
    //     name: 'dateISO',
    //     validator: CustomValidators.dateISO,
    //     message: '',
    //     parameters: false,
    //     parameter_type: 'string'
    // },
    // {
    //     name: 'creditCard',
    //     validator: CustomValidators.creditCard,
    //     message: '',
    //     parameters: false,
    //     parameter_type: 'string'
    // },
    {
        name: 'json',
        validator: CustomValidators.json,
        message: 'The {{attribute}} must be a valid JSON string.',
        parameters: false,
        parameter_type: 'string'
    },
    // {
    //     name: 'base64',
    //     validator: CustomValidators.base64,
    //     message: '',
    //     parameters: false,
    //     parameter_type: 'string'
    // },
    // {
    //     name: 'phone',
    //     validator: CustomValidators.phone,
    //     message: '',
    //     parameters: true,
    //     parameter_type: 'string'
    // },
    // {
    //     name: 'uuid',
    //     validator: CustomValidators.uuid,
    //     message: '',
    //     parameters: true,
    //     parameter_type: 'string'
    // },
    {
        name: 'equal',
        validator: equal,
        message: 'The {{attribute}} and {{other}} must match.',
        parameters: true,
        parameter_type: 'string'
    },
    // {
    //     name: 'notEqual',
    //     validator: notEqual,
    //     message: '',
    //     parameters: true,
    //     parameter_type: 'string'
    // },
    {
        name: 'equalTo',
        validator: CustomValidators.equalTo,
        message: 'The {{attribute}} and {{other}} must match.',
        parameters: true,
        parameter_type: 'string'
    },
    // {
    //     name: 'notEqualTo',
    //     validator: CustomValidators.notEqualTo,
    //     message: '',
    //     parameters: true,
    //     parameter_type: 'string'
    // },
];



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/form/validators.ts